/** Narrow app views plus touch-phone landscape, excluding short desktop windows/tablets. */
export function usesPhoneControls(width, height, coarsePointer) {
    return width < 768 || coarsePointer && height < 500 && width <= 1000;
}
/** Reclaim vertical space without changing the square scale or the future time horizon. */
export function boardProjection(available, width, anchor, gutter, zoom, phone, horizonS) {
    const referenceHeight = chartHeight(available, width, anchor, gutter, horizonS);
    return { height: phone ? Math.max(50, available) : referenceHeight, cell: referenceHeight / 6 * zoom };
}
export function isWholeCellVisible(x, y, cell, clip) {
    return Number.isFinite(x + y + cell) && cell > 0 && x >= 0 && y >= clip.top &&
        x + cell <= clip.width - clip.gutter && y + cell <= clip.height - clip.bottom;
}
export function containsPoint(x, y, cell, px, py) {
    return px >= x && px < x + cell && py >= y && py < y + cell;
}
export function isTap(startX, startY, x, y, canceled) {
    return !canceled && Math.hypot(x - startX, y - startY) <= 8;
}
export function chartHeight(available, width, anchor, gutter, horizonS) {
    // A fixed height for all zoom values preserves zoom. Fit two future windows at maximum zoom.
    const horizonHeight = horizonS ? Math.max(1, width * (1 - anchor) - gutter) * 30 / (.9 * horizonS) : available;
    return Math.max(50, Math.min(available, horizonHeight));
}
/** Fit the full label without changing its text or increasing its natural width. */
export function labelScale(naturalWidth, availableWidth) {
    return naturalWidth > 0 ? Math.min(1, Math.max(0, availableWidth) / naturalWidth) : 1;
}
//# sourceMappingURL=geometry.js.map